import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../redux/actions/modalActions";
import "./Modal.css";

const Modal = () => {
  const dispatch = useDispatch();
  const { isOpen, title, content } = useSelector((state) => state.modalReducer);

  if (!isOpen) return null;

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <div className="modal-overlay " onClick={handleClose}>
      <div
        className="modal-content modal-scroll"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={handleClose}>
            ×
          </button>
        </div>
        <div className="modal-body">{content}</div>
      </div>
    </div>
  );
};

export default Modal;
